/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DevisResumeSouscripteurDto } from './DevisResumeSouscripteurDto';
import {
    DevisResumeSouscripteurDtoFromJSON,
    DevisResumeSouscripteurDtoFromJSONTyped,
    DevisResumeSouscripteurDtoToJSON,
    DevisResumeSouscripteurDtoToJSONTyped,
} from './DevisResumeSouscripteurDto';

/**
 * Summary of the quote under validation, whatever its branch.
 * @export
 * @interface DevisResumeDto
 */
export interface DevisResumeDto {
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    devisId: string;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    identifiantDevis?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    identifiantDossier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    codeBranche?: string | null;
    /**
     * Product label.
     * @type {string}
     * @memberof DevisResumeDto
     */
    produit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    tunnelDesignation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    courtierNom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    demandeePar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisResumeDto
     */
    plateformeNom?: string | null;
    /**
     * 
     * @type {Array<DevisResumeSouscripteurDto>}
     * @memberof DevisResumeDto
     */
    souscripteurs: Array<DevisResumeSouscripteurDto>;
    /**
     * 
     * @type {number}
     * @memberof DevisResumeDto
     */
    prixHt: number;
    /**
     * 
     * @type {number}
     * @memberof DevisResumeDto
     */
    prixTtc: number;
    /**
     * 
     * @type {number}
     * @memberof DevisResumeDto
     */
    prixClient: number;
}

/**
 * Check if a given object implements the DevisResumeDto interface.
 */
export function instanceOfDevisResumeDto(value: object): value is DevisResumeDto {
    if (!('devisId' in value) || value['devisId'] === undefined) return false;
    if (!('souscripteurs' in value) || value['souscripteurs'] === undefined) return false;
    if (!('prixHt' in value) || value['prixHt'] === undefined) return false;
    if (!('prixTtc' in value) || value['prixTtc'] === undefined) return false;
    if (!('prixClient' in value) || value['prixClient'] === undefined) return false;
    return true;
}

export function DevisResumeDtoFromJSON(json: any): DevisResumeDto {
    return DevisResumeDtoFromJSONTyped(json, false);
}

export function DevisResumeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevisResumeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'devisId': json['devisId'],
        'identifiantDevis': json['identifiantDevis'] == null ? undefined : json['identifiantDevis'],
        'identifiantDossier': json['identifiantDossier'] == null ? undefined : json['identifiantDossier'],
        'codeBranche': json['codeBranche'] == null ? undefined : json['codeBranche'],
        'produit': json['produit'] == null ? undefined : json['produit'],
        'tunnelDesignation': json['tunnelDesignation'] == null ? undefined : json['tunnelDesignation'],
        'courtierNom': json['courtierNom'] == null ? undefined : json['courtierNom'],
        'demandeePar': json['demandeePar'] == null ? undefined : json['demandeePar'],
        'plateformeNom': json['plateformeNom'] == null ? undefined : json['plateformeNom'],
        'souscripteurs': ((json['souscripteurs'] as Array<any>).map(DevisResumeSouscripteurDtoFromJSON)),
        'prixHt': json['prixHt'],
        'prixTtc': json['prixTtc'],
        'prixClient': json['prixClient'],
    };
}

export function DevisResumeDtoToJSON(json: any): DevisResumeDto {
    return DevisResumeDtoToJSONTyped(json, false);
}

export function DevisResumeDtoToJSONTyped(value?: DevisResumeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'devisId': value['devisId'],
        'identifiantDevis': value['identifiantDevis'],
        'identifiantDossier': value['identifiantDossier'],
        'codeBranche': value['codeBranche'],
        'produit': value['produit'],
        'tunnelDesignation': value['tunnelDesignation'],
        'courtierNom': value['courtierNom'],
        'demandeePar': value['demandeePar'],
        'plateformeNom': value['plateformeNom'],
        'souscripteurs': ((value['souscripteurs'] as Array<any>).map(DevisResumeSouscripteurDtoToJSON)),
        'prixHt': value['prixHt'],
        'prixTtc': value['prixTtc'],
        'prixClient': value['prixClient'],
    };
}

